import JraEncodeDecodeModule from './JraEncodeDecodeModule';

export default class JraSecondary extends JraEncodeDecodeModule {
  constructor(element, encodeDecodeKey) {
    super(encodeDecodeKey);

    this.element = element;

    this.secondaryEmailInput = this.element.querySelector('[data-jra-form-secondary-email]');
  }
}
